import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-077dadb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-logo__wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 2,
  class: "company-logo__avatar",
  "data-test-id": "selected-company-name"
}

import { computed } from 'vue'
import { useCompanyLogoQuery } from '@/queries/settings.queries'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/store/auth'

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyLogo',
  props: {
  size: {
    type: Number,
    default: 64,
  },
  width: {
    type: Number,
    default: 64,
  },
  height: {
    type: Number,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

const authStore = useAuthStore()
const { selectedCompanyId, selectedCompany } = storeToRefs(authStore)

/* eslint-disable */



const style = computed(() => {
  const finalHeight = props.height || props.size + 'px'
  const finalWidth = props.width || props.size + 'px'
  return {
    width: finalWidth,
    minWidth: finalWidth,
    height: finalHeight,
    minHeight: finalHeight,
  }
})

const {
  isLoading: isLoading,
  isError: isError,
  data: companyLogo,
  error: error,
} = useCompanyLogoQuery(selectedCompanyId)

const getImage = (item: any) => {
  if (!item.file) {
    return null
  }
  // Check if we area dealing with an unsaved file
  // in which case item.file is a Blob object
  if (typeof item.file === 'object') {
    return URL.createObjectURL(item.file as Blob)
  }
  // item.file is not an object so it should be a path string
  // First we check if it is full path, in that case we do not need to modify it
  const fileUrlPath = item.file
  if (fileUrlPath.startsWith('http')) {
    return fileUrlPath
  }
  // Because we get only relative paths we need to prefix base url ourselves
  // Because base url ends with "/" and relative path starts with "/" we need to remove one of them to get correct urls
  let baseUrl = process.env.VUE_APP_API_URL
  if (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.substring(0, baseUrl.length - 1)
  }
  return baseUrl + fileUrlPath
}

return (_ctx: any,_cache: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : (_unref(companyLogo).file)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "company-logo__icon",
            style: _normalizeStyle(_unref(style)),
            src: getImage(_unref(companyLogo))
          }, null, 12, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(selectedCompany)?.company.name || '-'), 1))
  ]))
}
}

})